// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__32LXv","icon":"SortAdornment_icon__kkMsQ","up":"SortAdornment_up__1BiLd","down":"SortAdornment_down__3u3yM","active":"SortAdornment_active__2cjdm"};